import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import NewsletterCTA from "@/components/NewsletterCTA";
import usePageMeta from "@/lib/useSeo";

export default function About() {
  const [c, setC] = useState({});
  usePageMeta({
    title: "About · Vape Essence",
    description:
      "The story behind Vape Essence — authentic disposable vapes and nicotine pouches, sourced and tasted by our team. 100% authentic, 48-72hr delivery in SA.",
  });
  useEffect(() => {
    api.get("/content").then((r) => setC(r.data));
  }, []);

  return (
    <div>
      <section className="mx-auto max-w-[1400px] px-4 py-16 sm:px-6 sm:py-24 lg:px-10 lg:py-32">
        <div className="font-label text-xs text-[#FF5A1F]">/ ABOUT US</div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-3 max-w-3xl font-display text-4xl font-black leading-[0.95] tracking-tighter sm:text-5xl lg:text-7xl"
        >
          {c.about_title || "The Essence of Every Puff"}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-6 sm:mt-10 max-w-2xl text-sm sm:text-lg leading-relaxed text-white/70"
        >
          {c.about_body}
        </motion.p>
      </section>

      <section className="border-y border-white/10 bg-[#080808]">
        <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 sm:py-20 lg:px-10">
          <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
            {(c.about_pillars || []).map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15 }}
                className="border border-white/10 bg-black p-5 sm:p-10"
              >
                <div className="font-label text-xs text-[#00FFC2]">/ 0{i + 1}</div>
                <div className="mt-3 sm:mt-4 font-display text-xl sm:text-2xl font-black tracking-tighter">{p.title}</div>
                <p className="mt-2 sm:mt-3 text-sm text-white/60">{p.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-4 py-16 sm:px-6 sm:py-24 lg:px-10 lg:py-32">
        <div className="grid gap-8 sm:gap-16 md:grid-cols-2 items-center">
          <div>
            <div className="font-label text-xs text-[#FFC900]">/ OUR PROMISE</div>
            <h2 className="mt-3 font-display text-3xl font-black tracking-tighter sm:text-4xl lg:text-5xl">
              Flavour without the fine print.
            </h2>
            <p className="mt-5 sm:mt-6 text-sm sm:text-base text-white/60 leading-relaxed">
              We built Vape Essence because the market was flooded with counterfeits and
              questionable stock. Our team hand-tests every SKU before it hits the store —
              from the first note of flavour to the last puff — so what shows up at your door
              is exactly what the brand intended.
            </p>
            <p className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">
              Every rand you spend also earns you loyalty points, redeemable on any future
              order. No monthly caps. No expiries within reason. Just points that stack up
              and pay you back.
            </p>
          </div>
          <div className="relative aspect-[4/5] border border-white/10 overflow-hidden">
            <img
              src="https://images.pexels.com/photos/15410593/pexels-photo-15410593.jpeg?w=1000"
              alt=""
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        </div>
      </section>

      <NewsletterCTA />
    </div>
  );
}
